import { withRouter, Link } from 'react-router-dom';
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { types } from 'mobx-state-tree';
import {
  Button
} from 'react-bootstrap';
import LoggedinUser from '../../models/LoggedinUser';
import ListErrors from '../../components/ListErrors';
import Footer from '../../components/footer/Footer';


// css
const notsubscriberstyle = require('./notsubscriber.css');


interface Props {
  loggedinUser: typeof LoggedinUser.Type;
}

@observer
export default class NotSubscriber extends React.Component<{ loggedinUser: typeof LoggedinUser.Type }> {

  render() {
    const errors: string = this.props.loggedinUser.properties.errors;

    const callTo: string = 'tel:';
    const notSubscPhonenumber: string = callTo.concat(this.props.loggedinUser.branding.fullPhoneNumber);

    const mailTo: string = 'mailto:';
    const notSubscMailadress: string = mailTo.concat(this.props.loggedinUser.branding.mailAddress);

    const astyle = {
      color: '#F24962',
    };

    // images
    const branding = 'advoco'; //always branding 'advoco'
    const imgNotSubscriber = require('../../images/branding/' + branding + '/loginAndNotSubscriber_bg.jpg');
    const imgLogInStar = require('../../images/star32x32.png');

    // We need to check that we allows Urls (when inApp Browser we do not allow Urls):
    const allowUrls = this.props.loggedinUser.view.allowUrls;
    //contactUs with or without Url
    const contactUs = allowUrls ? (
      <div>maila <a href={notSubscMailadress} style={astyle}>{this.props.loggedinUser.branding.mailAddress}</a> eller ring <a href={notSubscPhonenumber} style={astyle}>{this.props.loggedinUser.branding.displayPhoneNumber}</a></div>
    ) : (
        <div>maila <span style={astyle}>{this.props.loggedinUser.branding.mailAddress}</span> eller ring <span style={astyle}>{this.props.loggedinUser.branding.displayPhoneNumber}</span></div>
    );
    //getSubscription with or without Url
    const getSubscription = allowUrls ? (
      <h4 className="notsubscr_features_headline_2"><a href={this.props.loggedinUser.branding.getSubscriptionUrl} style={astyle}>att skaffa {this.props.loggedinUser.branding.displayName}-abonnemang</a></h4>
    ) : (
      <h4 className="notsubscr_features_headline_2"><span style={astyle}>att skaffa {this.props.loggedinUser.branding.displayName}-abonnemang</span></h4>
    );


    return (
      <div className="auth-page">
        <div className="container page">
          <div className="row">
            <div className="notsubscr_login-imgdiv">
              <div className="notsubscr-image">
                <img src={imgNotSubscriber} className="notsubscr_login-img" alt="NotSubscriber" />
              </div>
              <div className="grid-div">
                <div className="notsubscr_login_grid">
                  <div className="notsubscr_login_header_box">
                    <div>Hej {this.props.loggedinUser.firstName}!</div>
                  </div>
                  <div className="notsubscr_login_forgotPassword_surf_box">
                    <div>Det verkar som att du inte har ett</div>
                    <div>mobilabonnemang hos oss på {this.props.loggedinUser.branding.displayName}.</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="notsubscr_features_grid">
              <div className="notsubscr_features_headline_box">
                <h3 className="notsubscr_features_headline">Välkommen</h3>
                {/* <h4 className="notsubscr_features_headline_2"><a href={this.props.loggedinUser.branding.getSubscriptionUrl} style={a_style}>att skaffa {this.props.loggedinUser.branding.displayName}-abonnemang</a></h4> */}
                {getSubscription}
              </div>
              <div className="notsubscr_features_smaller_headline_box">
                <div>Vi hjälper dig att komma igång</div>
                {/* <div>maila <a href={notSubscMailadress} style={a_style}>{this.props.loggedinUser.branding.mailAddress}</a> eller ring <a href={notSubscPhonenumber} style={a_style}>{this.props.loggedinUser.branding.displayPhoneNumber}</a></div> */}
                {contactUs}
              </div>
            </div>
            <div className="footerDiv">
              <Footer loggedinUser={this.props.loggedinUser} />
            </div>
          </div>
        </div>
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/notsubscriber/NotSubscriber.tsx